import { render, staticRenderFns } from "./bonus_mall.vue?vue&type=template&id=1772e4d8&scoped=true&"
import script from "./bonus_mall.vue?vue&type=script&lang=js&"
export * from "./bonus_mall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1772e4d8",
  null
  
)

export default component.exports